import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicProductCompositePaymentPeriod } from '../../enums/public-product-composite-payment-period';
import { PublicSalesResponse } from '@web/shared/module/shop';

@jsonObject
export class PublicProductCompositeCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly headline!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(String)
  public readonly paymentPeriod!: PublicProductCompositePaymentPeriod;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;
}
